export default __webpack_public_path__ + "static/media/home-restaurant-img-07.eae4691d.png";